import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind", "textileFields"]

  connect() {
    this.sync()
  }

  sync() {
    const object = this.kindTarget.value === "object"
    const panel = this.element.closest("[data-manual-panel]")
    this.textileFieldsTarget.hidden = object
    this.element.querySelectorAll("input, select, textarea").forEach(input => {
      input.disabled = Boolean(panel?.hidden) || (object && this.textileFieldsTarget.contains(input))
    })
  }
}
